/* ═══ A PÁGINA DE FAVORITOS — monta a grade a partir da lista do navegador ═══
   🔑 O SERVIDOR MANDA OS DADOS, O NAVEGADOR ESCOLHE. A página é servida em
     cache pela CDN, igual para todo mundo; só aqui se sabe o que ESTA pessoa
     guardou. Por isso o Liquid entrega o catálogo como JSON e este script
     desenha apenas o que está na lista.
   🪤 A ORDEM É A DE QUEM FAVORITOU, não a do catálogo. Quem guarda três peças
     em sequência espera vê-las nessa sequência — a ordem do catálogo faria a
     lista parecer embaralhada sem motivo.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var CHAVE = 'ettore:favoritos';
  var grade = document.querySelector('[data-favs-grade]');
  var vazio = document.querySelector('[data-favs-vazio]');
  var fonte = document.querySelector('[data-favs-dados]');
  if (!grade || !fonte) return;

  var catalogo = [];
  try { catalogo = JSON.parse(fonte.textContent); } catch (e) { catalogo = []; }
  var porHandle = {};
  catalogo.forEach(function (p) { porHandle[p.h] = p; });

  function ler() {
    try { return JSON.parse(localStorage.getItem(CHAVE) || '[]'); } catch (e) { return []; }
  }

  function escapa(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function desenha() {
    var lista = ler().map(function (h) { return porHandle[h]; }).filter(Boolean);

    if (!lista.length) {
      grade.hidden = true; grade.innerHTML = '';
      if (vazio) vazio.hidden = false;
      return;
    }
    if (vazio) vazio.hidden = true;
    grade.hidden = false;

    grade.innerHTML = lista.map(function (p) {
      return '<article class="favs-c">' +
        '<a class="favs-foto" href="' + escapa(p.u) + '">' +
          (p.i ? '<img src="' + escapa(p.i) + '" alt="' + escapa(p.t) + '" loading="lazy" width="500" height="500">' : '') +
          (p.d ? '' : '<span class="favs-esg">Esgotada</span>') +
        '</a>' +
        '<button type="button" class="favs-x" data-fav="' + escapa(p.h) + '" ' +
          'aria-label="Tirar ' + escapa(p.t) + ' dos favoritos">' +
          '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" aria-hidden="true">' +
          '<path d="M6 6l8 8M14 6l-8 8" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<a class="favs-nome" href="' + escapa(p.u) + '">' + escapa(p.t) + '</a>' +
        '<p class="favs-preco">' +
          (p.c ? '<s>' + escapa(p.c) + '</s> ' : '') + escapa(p.p) +
        '</p>' +
      '</article>';
    }).join('');
  }

  /* o coração de qualquer lugar avisa; aqui a grade se redesenha */
  document.addEventListener('ettore:favoritos', desenha);
  window.addEventListener('storage', function (e) { if (e.key === CHAVE) desenha(); });
  desenha();
})();
